import { TagManagerWrapperOwnProperties, TagManagerWrapperPropsFromState } from './types';
import { State } from '../../../../../types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { isTaggingServiceAvailable } from '../../../selectors/tags/Tags.selector';
import TagManagerWrapper from '../../../components/assets/details/TagManagerWrapper';
import { withRouter } from '../../../utils/routerUtils';

export type TagManagerWrapperProperties = TagManagerWrapperPropsFromState & TagManagerWrapperOwnProperties;

function mapStateToProps(state: State): TagManagerWrapperPropsFromState {
    return {
        taggingServiceIsAvailable: isTaggingServiceAvailable(state),
    };
}

const TagManagerWrapperContainer = withRouter(connect(mapStateToProps)(injectIntl(TagManagerWrapper)));

export default TagManagerWrapperContainer;
